


import React, { useEffect, useState } from "react";
import TableComponent from "../../components/TableComponent";
import {
  CurrencyDollarIcon,
  ExclamationCircleIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { toast } from "react-toastify";
import MembershipFeeModal from "../../components/admin/MembershipfeeModal";
import PayMembershipFeeModal from "../../components/admin/PayMembershipfeeModal";
import RemindMembershipFeeModal from "../../components/admin/RemindMembershipFeeModal";
import AuditHistoryButton, {
  canViewAuditHistory,
} from "../../components/admin/AuditHistoryButton";
import { formatCurrencyVND, formatDate } from "../../utils/helps";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import ApiCustom from "../../utils/ApiCustom";

const MembershipFees = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPayMembershipFeeModalOpen, setIsPayMembershipFeeModalOpen] =
    useState(false);
  const [payMembershipFeeModalMode, setPayMembershipFeeModalMode] =
    useState("all");
  const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
  const [currentMembershipFee, setCurrentMembershipFee] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [membershipFees, setMembershipFees] = useState([]);
  const [allCompanies, setAllCompanies] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  const hasPermission = (requiredPermission) => {
    const userId = localStorage.getItem("userId");
    if (userId == 1) {
      return true;
    }
    const userPermissions = getUserPermissions();
    return userPermissions.includes(requiredPermission);
  };

  const getUserPermissions = () => {
    const permissions = localStorage.getItem("permissions");
    return permissions
      ? JSON.parse(permissions)?.map((permission) => permission.permissionSlug)
      : [];
  };

  const filteredMembershipFees = membershipFees.filter((item) =>
    searchValue === ""
      ? true
      : [item.title].some((field) =>
          field?.toLowerCase().includes(searchValue.toLowerCase())
        )
  );

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    ApiCustom("/membership-fee-shows")
      .then((response) => {
        if (response.status == 200) {
          setMembershipFees(response.data?.data?.data);
        }
      })
      .catch((error) => console.log(error));

    fetchCompanies();
  };

  const fetchCompanies = async () => {
    try {
      const response = await ApiCustom.get("/company-approved");
      if (response.status === 200) {
        const approvedCompanies =
          response.data?.data?.data?.users?.filter((item) => {
            return item.approvalStatus == "Đã duyệt";
          }) || [];
        setAllCompanies(approvedCompanies || []);
      }
    } catch (error) {
      console.error("Error fetching selectedCompanies:", error);
    }
  };

  const handleOpenDeleteModal = (id) => {
    setDeleteId(id);
    setIsDeleteOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteId(null);
    setIsDeleteOpen(false);
    getData();
  };

  const handleDeleteMembershipFee = async () => {
    try {
      await ApiCustom.delete(`/membership-fee-delete/${deleteId}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status == 200) {
            toast.success("Xóa hội phí thành công!");
            handleCloseDeleteModal();
          }
        })
        .catch((error) => {
          if (error?.response?.status == 422) {
            handleCloseDeleteModal();
            toast.error(
              error?.response?.data?.messages || "Đã xảy ra lỗi!"
            );
            return;
          }
          toast.error("Đã xảy ra lỗi! Vui lòng thử lại.");
        });
    } catch (error) {
      toast.error("Đã xảy ra lỗi! Vui lòng thử lại.");
    }
  };

  const handleOpenModal = (membershipFee = null) => {
    setCurrentMembershipFee(membershipFee);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const handlePayMembershipFeeOpenModal = (
    membershipFee,
    mode = "all"
  ) => {
    setCurrentMembershipFee(membershipFee);
    setPayMembershipFeeModalMode(mode);
    setIsPayMembershipFeeModalOpen(true);
  };

  const handleClosePayMembershipFeeModal = () => {
    setIsPayMembershipFeeModalOpen(false);
    getData();
  };

  const handleOpenReminderFromUnpaidList = (membershipFee) => {
    setCurrentMembershipFee(membershipFee);
    setIsPayMembershipFeeModalOpen(false);
    setIsReminderModalOpen(true);
  };

  const handleReminderCloseModal = () => {
    setIsReminderModalOpen(false);
  };

  const tableSettings = {
    renderSettings: (item) => (
      <div className="flex space-x-2">
        {hasPermission("MEMBERSHIP_FEE_UPDATE") && (
          <button
            title="Chỉnh sửa hội phí"
            onClick={() => handleOpenModal(item)}
            className="btn btn-outline btn-info btn-sm my-1 rounded px-3"
          >
            <PencilSquareIcon className="h-5 w-5" />
          </button>
        )}

        {hasPermission("MEMBERSHIP_FEE_UPDATE") && (
          <button
            title="Danh sách đóng hội phí"
            onClick={() => handlePayMembershipFeeOpenModal(item, "all")}
            className="btn btn-outline btn-success btn-sm my-1 rounded px-3"
          >
            <CurrencyDollarIcon className="h-5 w-5" />
          </button>
        )}

        {hasPermission("MEMBERSHIP_FEE_UPDATE") && (
          <button
            title="Hội viên chưa đóng hội phí"
            onClick={() => handlePayMembershipFeeOpenModal(item, "unpaid")}
            className="btn btn-outline btn-warning btn-sm my-1 rounded px-3"
          >
            <ExclamationCircleIcon className="h-5 w-5" />
          </button>
        )}

        {hasPermission("MEMBERSHIP_FEE_DELETE") && (
          <button
            title="Xóa hội phí"
            onClick={() => handleOpenDeleteModal(item.id)}
            className="btn btn-outline btn-error btn-sm my-1 rounded px-3"
          >
            <TrashIcon className="h-5 w-5" />
          </button>
        )}
        <AuditHistoryButton
          module="MEMBERSHIP_FEE"
          entityType="MembershipFee"
          entityId={item.id}
        />
      </div>
    ),
  };

  const headers = [
    { key: "title", label: "Chủ đề" },
    {
      key: "fee",
      label: "Số tiền",
      render: (item) => (
        <div>
          <p className="font-medium">{formatCurrencyVND(item.fee)}</p>
        </div>
      ),
    },
    {
      key: "paysStartDay",
      label: "Ngày bắt đầu đóng",
      render: (item) => (
        <div>
          <p className="font-medium">{formatDate(item.payStartDay)}</p>
        </div>
      ),
    },
  ];

  if (
    hasPermission("MEMBERSHIP_FEE_UPDATE") ||
    hasPermission("MEMBERSHIP_FEE_DELETE") ||
    canViewAuditHistory()
  ) {
    headers.push({ key: "setting", label: "Phương thức" });
  }

  return (
    <div className="p-6">
      <h1 className="mb-4 text-2xl font-semibold">Quản lý hội phí</h1>

      <div className="mb-4 block items-center justify-between md:flex">
        {hasPermission("MEMBERSHIP_FEE_CREATE") ? (
          <button
            onClick={() => handleOpenModal()}
            className="btn btn-success mb-4 rounded px-4 py-2 transition-colors"
          >
            + Thêm Hội Phí
          </button>
        ) : (
          <div />
        )}

        <div className="flex gap-2">
          <div className="flex items-center space-x-2">
            <label
              htmlFor="membershipFeeSearch"
              className="w-24 text-sm font-medium"
            >
              Tìm kiếm:
            </label>
            <input
              id="membershipFeeSearch"
              type="search"
              className="w-full rounded-lg border px-2 py-1 pr-10 focus:outline-none"
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="rounded-lg shadow">
        <TableComponent
          headers={headers}
          data={filteredMembershipFees}
          settings={tableSettings}
        />
      </div>

      {isModalOpen && (
        <MembershipFeeModal
          allCompanies={allCompanies}
          membershipFeeId={currentMembershipFee?.id || null}
          onClose={handleCloseModal}
        />
      )}

      {isPayMembershipFeeModalOpen && (
        <PayMembershipFeeModal
          membershipFeeId={currentMembershipFee?.id || null}
          unpaidOnly={payMembershipFeeModalMode === "unpaid"}
          onOpenReminder={handleOpenReminderFromUnpaidList}
          onClose={handleClosePayMembershipFeeModal}
        />
      )}

      {isReminderModalOpen && currentMembershipFee && (
        <RemindMembershipFeeModal
          membershipFee={currentMembershipFee}
          onClose={handleReminderCloseModal}
        />
      )}

      <ConfirmDeleteModal
        isOpen={isDeleteOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDeleteMembershipFee}
      />
    </div>
  );
};

export default MembershipFees;




